/**
 * DailyTransactionsModal 컴포넌트
 *
 * 선택한 날짜의 거래 목록을 표시하는 모달
 * - TransactionItem 컴포넌트 재사용
 * - 날짜 표시 (YYYY년 MM월 DD일)
 * - 거래 없으면 안내 메시지
 */

import type { Transaction } from '@/domains/transaction/types/Transaction'
import type { PaymentMethod } from '@/domains/payment/types/PaymentMethod'
import type { User } from '@/domains/user/types/User'
import type { Category } from '@/domains/category/types/Category'
import { Modal } from '@/shared/components/ui/Modal'
import { TransactionList } from './TransactionList'

interface DailyTransactionsModalProps {
  isOpen: boolean
  date: Date | null
  transactions: Transaction[]
  paymentMethods: PaymentMethod[]
  users: User[]
  categories: Category[]
  onClose: () => void
  onTransactionLongPress?: (id: string) => void
}

export function DailyTransactionsModal({
  isOpen,
  date,
  transactions,
  paymentMethods,
  users,
  categories,
  onClose,
  onTransactionLongPress,
}: DailyTransactionsModalProps) {
  if (!date) return null

  // 날짜 포맷: YYYY년 MM월 DD일
  const year = date.getFullYear()
  const month = date.getMonth() + 1
  const day = date.getDate()
  const formattedDate = `${year}년 ${month}월 ${day}일`

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={formattedDate} size="md">
      <div className="-mx-6">
        <TransactionList
          transactions={transactions}
          paymentMethods={paymentMethods}
          users={users}
          categories={categories}
          onTransactionLongPress={onTransactionLongPress}
          inModal={true}
          displayMode="full"
        />
      </div>
    </Modal>
  )
}
